import Box from '@mui/material/Box';
import React, { useState, useRef } from 'react';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { getIcon } from '../../shared/utils/_icons.jsx';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

export const TabComponent = ((props) => {
    const { index, value } = props;
    const [oscarId, setId] = useState("")
    const [inputSavings, setInputSavings] = useState("")
    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }
    return (<>

        <CustomTabPanel value={value} index={index}>
            <React.Fragment>
                <Grid container spacing={1}>
                    <Grid item xs={4} md={4} lg={4} sm={4}>
                        <div sx={{ height: '20px', padding: '5px' }}>"test"</div>
                    </Grid>
                    <Grid item xs={8} md={8} lg={8} sm={8}>
                        <>

                        <input type="text" value={oscarId}
                                id="outlined-size-small2"
                                onChange={(event) => {
                                    setId(event.target.value)
                                }}/>

                             <input type="number" value={inputSavings}
                                id="outlined-size-small2"
                                onChange={(event) => {
                                    setInputSavings(event.target.value)
                                }}/>
                            {/* {<TextField
                                value={oscarId}
                                id="outlined-size-small2"
                                onChange={(event) => {
                                    console.log("text: onchange")
                                    console.log("New value ::", event.target.value)
                                    setId(event.target.value)
                                }}
                                onBlur={(event) => {
                                    console.log("text: onBlur", event.target.value)
                                    setId(event.target.value)
                                }}
                            />}
                            {<TextField
                                variant="outlined"
                                type="number"
                                id="outlined-size-small"
                                // defaultValue="Hello World"
                                value={inputSavings}
                                onChange={(event) => {
                                    console.log("number: onchange")
                                    console.log("New value ::", event.target.value)
                                    setInputSavings(event.target.value)
                                }}
                                onBlur={(event) => {
                                    console.log("number: onblur")
                                    console.log("New value ::", event.target.value)
                                    setInputSavings(event.target.value)
                                }}
                            />} */}
                        </>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} sm={12}>&nbsp;</Grid>
                </Grid>
            </React.Fragment>
        </CustomTabPanel>
        <Button
            onClick={() => {
                console.log(":::: oscar Id, inputSavings :::", oscarId, inputSavings)

            }}
            variant='contained'
            size='medium'
            className={'Apply-changes-button'}
            startIcon={getIcon('Save')}
            disabled={false}>
            Save data
        </Button>
    </>)
});